<template>
  <div>
    <p class="category">User Profile Modeling</p>
    <div class="container text-left">
      <p>
        User profile modeling tasks aim to predict user's attributes, such as gender, age, education, region,
        occupation, income, etc., which can be used to help characterize potential users in various applications such as
        e-commerce and social networks.
        This task predicts the user's emotional state and recent work in the past month by analyzing the historical
        texts posted by the user.
        Using the method of user modeling, we can track the user attributes in the process of event propagation, helping
        us to grasp the propagation law of social hot events.
      </p>
      <p>
        The dataset is organized in the csv format.
        The table below presents a user instance, and the meaning of related fields.
      </p>
      <div class="my-3">
        <el-table :data="tableData" style="width: 100%" border :default-sort="{prop: 'mid', order: 'ascending'}">
          <el-table-column prop="field" label="Field" min-width="150"></el-table-column>
          <el-table-column prop="content" label="Content" min-width="300"></el-table-column>
          <el-table-column prop="meaning" label="Meaning" min-width="300"></el-table-column>
        </el-table>
      </div>
      <div>
        <span class="h6 mr-2">Data resources: </span>
        <a href="/resource_social22/data/data_user.zip">data_user.zip</a>
      </div>
      <div>
        <span class="h6 mr-2">Baseline Implementation: </span>
        <a href="/resource_social22/data/src_user.zip">src_user.zip</a>
      </div>
      <p class="mt-3">Uploading results should be saved as a <strong>.json</strong> file like this:</p>
      <div>
        <json-tree :raw="data2str(responseData)"></json-tree>
      </div>
    </div>
  </div>
</template>

<script>
import JsonTree from "vue-json-tree";

export default {
  name: "taskUser",
  components: {JsonTree},
  data() {
    return {
      tableData: [
        {
          'field': 'id',
          'content': '12035',
          'meaning': 'The ID for the user',
        },
        {
          'field': 'weibo',
          'content': '[[\'明天马上要出成绩了 希望大家都棒棒哒！ \', \'2015-06-24\']]',
          'meaning': 'Historical weibo content for the user',
        },
        {
          'field': 'paper_time',
          'content': '2020/11/20',
          'meaning': 'When the user fill out the questionnaire',
        },
        {
          'field': 'emotion_label',
          'content': '0',
          'meaning': 'The user\'s emotion state in the past month ',
        },
        {
          'field': 'job_label',
          'content': '2',
          'meaning': 'The job type for the user',
        },
      ],
      responseData: {'id': [5817, 5586, 6778], 'emotion_preds': [0, 0, 0], 'job_preds': [1, 1, 1]},
    }
  },
  methods: {
    data2str(data) {
      return JSON.stringify(data);
    },
  },
}
</script>

<style scoped>

</style>